export type Serializable = {
  toJSON: () => unknown;
  // fromJSON: (json: unknown) => Promise<unknown>;
};

export const isSerializable = (value: unknown): value is Serializable => {
  return typeof value === "object" && value !== null && "toJSON" in value;
};
